var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-to-top",attrs:{"title":"Scroll to top"}},[_c('b-button',{attrs:{"icon-right":"chevron-up"},on:{"click":_vm.scrollToTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }